import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _isInteger from "lodash/isInteger";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import { useCallback, useContext, useMemo } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useWatch, useFieldArray as useFieldArrayRHF } from 'react-hook-form';
import { FormSymbolContext } from "./Form.context";
export function createUseFieldValuesHook(_ref) {
  var FormContext = _ref.FormContext;
  /**
   * Returns the object of field values whenever they change
   *
   * @param fieldNames An optional array of names of fields to subscribe to.
   * It is **STRONGLY** advised to use this field for performance reasons, unless
   * you need all the values (which is often not the case)
   * @returns An object of values that were subscribed to, or all the values if
   * fieldNames was not provided
   */
  return function useFieldValues(fieldNames) {
    if (typeof fieldNames !== 'undefined' && !Array.isArray(fieldNames)) {
      throw new Error("fieldNames must be an array of strings if it's defined");
    }
    if (fieldNames) {
      fieldNames.forEach(function (name) {
        return assertNoDots(name);
      });
    }
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useFieldValues must be used inside a grandchild of a Form or FormProvider');
    }
    var control = context.context.control;
    var value = useWatch(_objectSpread({
      control: control
    }, fieldNames && {
      name: fieldNames
    }));
    if (Array.isArray(value)) {
      // @ts-expect-error TS is wrong here but I can't figure out how to fix the error
      return convertArraysToObject(fieldNames, value);
    }

    // @ts-expect-error TS is wrong here but I can't figure out how to fix the error
    return value;
  };
}
export function createSetValues(setValue) {
  return function setValues(values, options) {
    /**
     * Okay so let's try to explain why `unstable_batchedUpdates` is used here
     *
     * In versions of react before React 18, if you caused a state update
     * in an async way (such as within a setTimeout or inside a fetch
     * callback) it causes multiple sequential re-renders
     *
     * For example,
     * ```
     * const [name, setName] = useState();
     * const [age, setAge] = useState();
     *
     * useEffect(() => {
     *  setTimeout(() => {
     *    setName('Han Solo')
     *    setAge(22);
     *  }, 1000)
     * }, [])
     * ```
     * The above code causes 2 renders instead of 1.  One render where
     * name is changed to 'Han Solo' and age is unchanged, and another
     * render with age correctly updated
     *
     * However, if you did this inside an event handler, react
     * automatically "batches" them:
     * ```
     * <button
     *  type="button"
     *  onClick={() => {
     *    setName('aaa')
     *    setAge(22);
     *  }}
     * >
     *   Set State
     * </button>
     * ```
     * In this case, react batches the renders together and only re-renders once.
     *
     * This batching is actually important not just for performance, but
     * for preventing bugs.  It's easy to write react code that assumes
     * values are updated at the same time.  If this assumption is
     * violated, then it can cause subtle bugs
     *
     * This is what the react team has said about batching:
     * > This is great for performance because it avoids unnecessary
     * > re-renders. It also prevents your component from rendering
     * > “half-finished” states where only one state variable was updated,
     * > which may cause bugs
     * > https://github.com/reactwg/react-18/discussions/21
     *
     * Unfortunately, react-hook-form only provides `setValue` and not
     * `setValues` so we have to do sequential state updates when updating
     * multiple form values
     *
     * In react 18, the react team made sequential state updates inside
     * async callbacks _also batch_.  So once we upgrade to react 18, we
     * can simply remove this.  This is another reason to use
     * unstable_batchedUpdates, because the change in batching behavior
     * would probably break a lot of spots in our app in hard-to-debug ways.
     *
     * Don't be afraid that it's prefixed with "unstable", because:
     * - The react team said it's fine to use this: https://github.com/facebook/react/commit/b41883fc708cd24d77dcaa767cde814b50b457fe#commitcomment-41826130
     * - Redux also uses this, and they consider this so stable that they re-exported it for public use without the prefix: https://react-redux.js.org/api/batch
     * - We can simply remove this when we upgrade to react 18. https://github.com/reactwg/react-18/discussions/21
     */
    unstable_batchedUpdates(function () {
      for (var key in values) {
        assertFieldArrayDepth(key);
        setValue(
        // @ts-expect-error This is type-safe for consumers but I can't figure out how to resolve this error atm
        key, values[key], options);
      }
    });
  };
}
export function createUseSetFieldValuesHook(_ref2) {
  var FormContext = _ref2.FormContext;
  return function useSetFieldValues() {
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useSetFieldValues must be used inside a grandchild of a Form or FormProvider');
    }
    var setValue = context.context.setValue;
    var setValues = useMemo(function () {
      return createSetValues(setValue);
    }, [setValue]);
    return useCallback(function (values, options) {
      return setValues(
      // @ts-expect-error Not sure how to fix this but it's fine at runtime
      values, options);
    }, [setValues]);
  };
}
export function createUseResetFormHook(_ref3) {
  var FormContext = _ref3.FormContext;
  /**
   * Resets all properties of the form, including values and error states.
   */
  return function useResetForm() {
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useResetForm must be used inside a grandchild of a Form or FormProvider');
    }
    var reset = context.context.reset;
    return useCallback(function () {
      return reset(context.defaultValues);
    }, [reset, context.defaultValues]);
  };
}
export function createUseGetFieldValuesHook(_ref4) {
  var FormContext = _ref4.FormContext;
  /**
   * Returns a function that when called gets the field values.  Use this when
   * you need the field values in an event handler, not during rendering.  If
   * you need the field values during rendering, use useFieldValues instead.
   */
  return function useGetFieldValues() {
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useGetFieldValues must be used inside a grandchild of a Form or FormProvider');
    }
    var getValues = context.context.getValues;
    return useCallback(function () {
      return getValues();
    }, [getValues]);
  };
}
export function createUseTriggerValidation(_ref5) {
  var FormContext = _ref5.FormContext;
  return function useTriggerValidation() {
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useTriggerValidation must be used inside a grandchild of a Form or FormProvider');
    }
    var trigger = context.context.trigger;
    return useCallback(function () {
      return trigger();
    }, [trigger]);
  };
}
export function createUseFieldArray(_ref6) {
  var FormContext = _ref6.FormContext,
    formSymbol = _ref6.formSymbol;
  return function useFieldArray(_ref7) {
    var name = _ref7.name;
    assertNoDots(name);
    var formSymbolContext = useContext(FormSymbolContext);
    var context = useContext(FormContext);
    if (!context || formSymbol !== formSymbolContext) {
      throw new Error('useFieldArray must be used inside a grandchild of a Form');
    }
    var control = context.context.control;
    var _useFieldArrayRHF = useFieldArrayRHF({
        // @ts-expect-error This is type-safe but I'm not sure how to fix the TS error
        name: name,
        control: control
      }),
      fields = _useFieldArrayRHF.fields,
      _append = _useFieldArrayRHF.append,
      _prepend = _useFieldArrayRHF.prepend,
      _remove = _useFieldArrayRHF.remove,
      move = _useFieldArrayRHF.move,
      swap = _useFieldArrayRHF.swap;

    // react-hook-form returns other properties besides `id`, but they don't
    // update when the user changes them.  This seems bug-prone so let's just
    // return the ID for now
    var transformedFields = useMemo(function () {
      return fields.map(function (field) {
        return {
          id: field.id
        };
      });
    }, [fields]);
    return {
      fields: transformedFields,
      prepend: function prepend(item) {
        if (!item || _typeof(item) !== 'object') {
          throw new Error('Must pass item to append');
        }

        // @ts-expect-error Not sure how to fix, will not be an error at runtime
        _prepend(item);
      },
      append: function append(item) {
        if (!item || _typeof(item) !== 'object') {
          throw new Error('Must pass item to append');
        }

        // @ts-expect-error Not sure how to fix, will not be an error at runtime
        _append(item);
      },
      remove: function remove(index) {
        if (typeof index !== 'number') {
          throw new Error('Must pass index to remove');
        }
        _remove(index);
      },
      move: move,
      swap: swap
    };
  };
}
export function createUseClearErrors(_ref8) {
  var FormContext = _ref8.FormContext;
  return function useClearErrors() {
    var context = useContext(FormContext);
    if (!context) {
      throw new Error('useClearErrors must be used inside a grandchild of a Form or FormProvider');
    }
    var clearErrors = context.context.clearErrors;
    return useCallback(function (arg) {
      return clearErrors(arg);
    }, [clearErrors]);
  };
}
function convertArraysToObject(keys, values) {
  return keys.reduce(function (acc, curr, idx) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, values[idx]));
  }, {});
}
function assertNoDots(name) {
  if (name.indexOf('.') > -1) {
    throw new Error('Nested paths are currently not supported');
  }
}
export function assertFieldArrayDepth(name) {
  if (name.indexOf('.') > -1) {
    var nameSplit = name.split('.');
    if (nameSplit.length > 3) {
      throw new Error('Must follow the format {string.number.string} or {string.number} when using dots in names');
    }
    if (!_isInteger(Number(nameSplit[1]))) {
      throw new Error('Only field arrays (an array of objects) are supported');
    }
  }
}